import { Pec } from 'shell/models/pec';
import { PecForm } from '../form';

export const transformSavePec = (values: PecForm): Pec => {
  return {
    ...(values.data || {}),
    pecDestinatarioVOList: values.receiver
      ? [
          {
            ...(values.data?.pecDestinatarioVOList ? values.data?.pecDestinatarioVOList[0] : {}),
            key: {
              idComunicazione: values.data?.key?.idComunicazione,
              destinatario: values.receiver,
            },
            descrizioneDestinatario: values.descRecipient || '',
          },
        ]
      : undefined,
    oggetto: values.subject || undefined,
    corpo: values.messageBody || undefined,
    allegati: values.attachments?.length
      ? [
          {
            ...(values.data?.allegati ? values.data?.allegati[0] : {}),
            contenutoAllegato: values.attachments[0].raw || '',
            nomeFile: values.attachments[0].name || '',
            tipoFile: values.attachments[0].type || '',
            mimeType: values.attachments[0].tipoAllegato || '',
          },
        ]
      : undefined,
  };
};
